import React from 'react'
import MonthSelector from './month-selector'
import moment from 'moment'
import WeekHeader from './week-header'
import getWeeksArrays from './get-weeks-arrays'
import Week from './week'
import Day from './day'
import { Spinner } from 'react-bootstrap'

const DateLabelColors = {
    DULL: 'rgb(180, 180, 180)',
    ACTIVE: 'rgb(0, 0, 0)',
    INVERTED: 'rgb(255, 255, 255)'
}

const DateDotColors = {
    PRIMARY: 'rgb(38, 153, 251)',
    INVERTED: 'rgb(255,255,255)',
    ALERT: 'rgb(225, 54, 25)'
}

const DateBackgroundColors = {
    ACTIVE_PRIMARY: 'rgb(38, 153, 251)',
    ACTIVE_ALERT: 'rgb(225, 54, 25)',
    INACTIVE_PRIMARY: 'rgb(136, 182, 249)',
    INACTIVE_ALERT: 'rgb(247, 195, 183)',
    INACTIVE_SECONDARY: 'rgb(187, 187, 187)'
}

const BasicCalendar = ({
    date = moment(),
    disabled,
    loading,
    onDateClicked = () => {},
    onGetDateLabelColor = () => {},
    onGetDateDotColor = () => {},
    onGetDateBackgroundColor = () => {}
}) => {
    const [ month, setMonth ] = React.useState(moment(date).month())
    const [ year, setYear ] = React.useState(moment(date).year())

    React.useEffect(() => {
        setMonth(moment(date).month())
        setYear(moment(date).year())
    }, [date])

    const weeks = getWeeksArrays(moment([year, month, 1]))

    const renderDay = (day, key) => {
        const today = moment([year, month, day])
        const todayString = today.format('YYYY-MM-DD')
        const dateLabelColor = onGetDateLabelColor(todayString)
        const dateDotColor = onGetDateDotColor(todayString)
        const dateBackgroundColor = onGetDateBackgroundColor(todayString)
        if (!day) {
            return (<Day key={key}> &nbsp; </Day>)
        }
        return (
            <Day
                disabled={disabled}
                dateLabelColor={dateLabelColor}
                dateDotColor={dateDotColor}
                dateBackgroundColor={dateBackgroundColor}
                onClick={() => onDateClicked(today.format('YYYY-MM-DD'))}
                key={key}
            >
                {day}
            </Day>
        )
    }

    const renderWeek = (days, key) => {
        return (<Week key={key}>{days.map(renderDay)}</Week>)
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'space-around', minWidth: '400px'}}>
            <div style={{ position: 'relative', maxWidth: '600px', minWidth: '400px' }}>
                <div
                    style={{
                        display: loading ? 'flex' : 'none',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        left: '1px',
                        top: '200',
                        width: '100%',
                        minHeight: '100%',
                        zIndex: '5', 
                        backgroundColor: 'rgba(110, 110, 110, 0.3)',
                    }}
                >
                    <Spinner animation="border" variant="primary" />
                </div>
                <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <MonthSelector
                        disabled={disabled}
                        month={month}
                        year={year}
                        onMonthChange={setMonth}
                        onYearChange={setYear}
                    />
                </div>
                <div>
                    <WeekHeader />
                </div>
                {weeks.map(renderWeek)}
            </div>
        </div>
    )
}

BasicCalendar.DateBackgroundColors = DateBackgroundColors
BasicCalendar.DateDotColors = DateDotColors
BasicCalendar.DateLabelColors = DateLabelColors

export default BasicCalendar